import { render, staticRenderFns } from "./OrderPaymentCard.vue?vue&type=template&id=0801f332&scoped=true&"
import script from "./OrderPaymentCard.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentCard.vue?vue&type=style&index=0&id=0801f332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801f332",
  null
  
)

export default component.exports